/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Datapoints
 */
export interface Datapoints {
}

/**
 * Check if a given object implements the Datapoints interface.
 */
export function instanceOfDatapoints(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatapointsFromJSON(json: any): Datapoints {
    return DatapointsFromJSONTyped(json, false);
}

export function DatapointsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Datapoints {
    return json;
}

export function DatapointsToJSON(value?: Datapoints | null): any {
    return value;
}

